import { memo } from 'react'
import { Outlet, useLocation } from 'react-router-dom'

import s from './MainLayout.module.scss'

import { useAuthContext } from 'contexts/AppAuthContext'
import { useAppErrorContext } from 'contexts/AppErrorContext'
import { useDeviceContext } from 'contexts/DeviceContext'
import { useAppSuccessMessageContext } from 'contexts/SuccessMessageContext'

import ErrorMessage from 'components/UI/ErrorMessage'
import Header from 'components/UI/Header'
import Sidebar from 'components/UI/Sidebar'
import SuccessMessage from 'components/UI/SuccessMessage'
import SessionIsExpiredModal from 'components/modals/SessionIsExpiredModal'

const MainPage = memo(() => {
  const {
    authData: { isSessionExpired, web3token },
    setIsSessionExpired,
  } = useAuthContext()
  const { appError } = useAppErrorContext()
  const { appSuccessMessage, setSuccessMessage } = useAppSuccessMessageContext()
  const location = useLocation()
  const { deviceType } = useDeviceContext()
  return (
    <div className={`${s.layout} ${location.pathname.includes('advertiser') ? s.secondary : s.primary}`}>
      <div
        className={s.publisherCabinet}
        id="idForPagination"
        style={{ marginLeft: deviceType === 'mobile' ? '0rem' : '13.25rem' }}
      >
        <Sidebar isLoggedIn={!!web3token} />
        {location.pathname === '/' && <Header />}
        <Outlet />
      </div>
      {isSessionExpired && <SessionIsExpiredModal onHide={() => setIsSessionExpired(false)} />}
      {appError && <ErrorMessage message={appError} />}
      {!appError && appSuccessMessage && (
        <SuccessMessage message={appSuccessMessage} onClose={() => setSuccessMessage('')} />
      )}
    </div>
  )
})

export default MainPage
